/* src/app/admin/client/client-area/client-area-report/client-area-report.component.scss */
.table-container {
  width: 100%;
}
.button-search {
  border-radius: 10px;
  padding: 2px;
  width: 37px;
  height: 37px;
  margin-left: 2px;
  margin-top: 16px;
}
h4 {
  margin: 20px 0;
}
.sidebar {
  position: relative;
  padding: 0;
  margin: 0;
  font-family: "Noto Sans", sans-serif;
}
.sidebar .search-container {
  display: flex;
  align-items: center;
  margin: 15px 0 30px;
  padding: 0;
  background-color: transparent;
}
.sidebar .search-input {
  flex-grow: 1;
  height: 40px;
  padding: 0 10px;
  border: 1px solid #ebebeb;
  border-radius: 10px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  outline-color: #006f8a;
  font-size: 14px;
}
.sidebar .search-input::placeholder {
  color: #999;
}
.sidebar .search-input:focus {
  outline: 1px solid;
  outline-offset: -2px;
}
.sidebar .search-button {
  cursor: pointer;
  width: 39px;
  height: 39px;
  margin-left: 2px;
  margin-top: 0;
  border: none;
  border-radius: 10px;
  background-color: #006f8a;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}
.sidebar .search-button:hover {
  background-color: #00576d;
}
.sidebar .report-list {
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 14px;
  color: #1d1d1d;
}
.sidebar .report-item {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  width: 100%;
  max-width: 400px;
  height: 40px;
}
.sidebar .report-item label {
  margin-right: 16px;
  color: #1d1d1d;
  font-size: 14px;
}
.sidebar .toggle-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 12px;
  font-weight: bold;
  color: white;
  pointer-events: none;
}
.sidebar .toggle-text.selected {
  color: white;
}
.sidebar .report-label {
  width: 100%;
}
/*# sourceMappingURL=client-area-report.component-6LTL6MQT.css.map */
